import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import Skeleton from "components/ui/Skeleton";
import { CATEGORY_META } from "../utils";

const CategoryBreakdown = ({ data, loading }) => {
  const rows = (data || []).map((d) => {
    const meta = CATEGORY_META[d.category] || { label: d.category, color: "var(--color-text-muted)" };
    return { ...d, label: meta.label, color: meta.color };
  });

  return (
    <div className="rounded-2xl border border-border bg-surface p-5">
      <h2 className="font-semibold text-text_primary mb-4">By Category</h2>

      {loading ? (
        <Skeleton className="h-40 w-full" rounded="rounded-xl" />
      ) : rows.length === 0 ? (
        <p className="text-sm text-text_muted py-10 text-center">No campaigns in this period</p>
      ) : (
        <div className="flex items-center gap-4">
          <div className="flex-shrink-0">
            <ResponsiveContainer width={120} height={120}>
              <PieChart>
                <Pie data={rows} dataKey="campaigns" nameKey="label" innerRadius={36} outerRadius={56} paddingAngle={2} stroke="none">
                  {rows.map((r, i) => <Cell key={i} fill={r.color} />)}
                </Pie>
                <Tooltip formatter={(v, n, p) => [`${v} campaigns`, p.payload.label]} />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="flex-1 space-y-2.5 min-w-0">
            {rows.map((r) => (
              <div key={r.category} className="flex items-center justify-between text-sm">
                <span className="flex items-center gap-2 text-text_secondary truncate">
                  <span className="w-2.5 h-2.5 rounded-sm inline-block flex-shrink-0" style={{ backgroundColor: r.color }} />
                  {r.label}
                </span>
                <span className="font-semibold text-text_primary tabular-nums">{r.campaigns}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryBreakdown;
